import React, { useEffect, useState } from "react";
import "./hamuga-deep-link.scss";

// Direct app link fallback when Universal Links/App Links don't open the app (e.g. on most devices)
const TOMKO_APP_SCHEME = "tomko://";
const REDIRECTING_DURATION_MS = 1000;

// App expects: tomko://auth/hamuga?code=XXX&state=YYY
const TOMKO_AUTH_PATH = "auth/hamuga";

const getTomkoDeepLinkUrl = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const code = searchParams.get("code");
  const state = searchParams.get("state");
  const params = new URLSearchParams();
  if (code != null) params.set("code", code);
  if (state != null) params.set("state", state);
  const query = params.toString() ? `?${params.toString()}` : "";
  return `${TOMKO_APP_SCHEME}${TOMKO_AUTH_PATH}${query}`;
};

const FALLBACK_DELAY_MS = 800;

const HamugaDeepLink = ({ data }) => {
  const [showRedirecting, setShowRedirecting] = useState(true);
  const [showFallback, setShowFallback] = useState(false);
  const redirectingText = data?.redirectingText || "Redirecting ...";
  const openAppFallback = data?.openAppFallback || "Open Tomko";
  const deepLinkUrl = getTomkoDeepLinkUrl();

  useEffect(() => {
    let fallbackTimer;
    const redirectTimer = setTimeout(() => {
      setShowRedirecting(false);
      window.location.href = deepLinkUrl;
      fallbackTimer = setTimeout(() => setShowFallback(true), FALLBACK_DELAY_MS);
    }, REDIRECTING_DURATION_MS);
    return () => {
      clearTimeout(redirectTimer);
      clearTimeout(fallbackTimer);
    };
  }, [deepLinkUrl]);

  const handleOpenApp = () => {
    window.location.href = deepLinkUrl;
  };

  return (
    <div className="hamuga-deep-link-container">
      <div className="hamuga-deep-link-content">
        <img
          className="hamuga-deep-link-logo"
          src="/images/tomko_logo_trans.png"
          alt="Tomko"
          width={174}
          height={156}
        />
        <div className="hamuga-greeting-container">
          {showRedirecting && <p className="redirecting-text">{redirectingText}</p>}
        </div>

        {showFallback && (
          <>
            <div className="hamuga-fallback-actions">
              <a
                href={deepLinkUrl}
                className="hamuga-open-app-button"
                onClick={(e) => {
                  e.preventDefault();
                  handleOpenApp();
                }}
                aria-label={openAppFallback}
              >
                {openAppFallback}
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default HamugaDeepLink;
